import { render, staticRenderFns } from "./OurServices.vue?vue&type=template&id=8e807b4c&scoped=true&"
import script from "./OurServices.vue?vue&type=script&lang=js&"
export * from "./OurServices.vue?vue&type=script&lang=js&"
import style0 from "./OurServices.vue?vue&type=style&index=0&id=8e807b4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e807b4c",
  null
  
)

export default component.exports